(function () {
  'use strict';

  var API_URL = 'https://api.zarena.bg/orders/one-click';

  var overlay = document.getElementById('one-click-buy-modal');
  var itemsContainer = document.getElementById('one-click-modal__items');
  var phoneInput = document.getElementById('one-click-phone');
  var phoneError = document.getElementById('one-click-phone-error');
  var submitBtn = document.getElementById('one-click-submit');
  var successEl = document.getElementById('one-click-success');
  var errorStateEl = document.getElementById('one-click-error-state');

  var pendingLineItems = [];
  var pendingSource = '';

  function isWithinWorkHours() {
    var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Sofia' }));
    var day = now.getDay(); // 0=Sun, 6=Sat
    var hour = now.getHours();
    return day >= 1 && day <= 5 && hour >= 8 && hour < 17;
  }

  // Hide buttons outside work hours (disabled for testing)
  // if (!isWithinWorkHours()) {
  //   document.querySelectorAll('[data-one-click-buy], [data-one-click-buy-cart]').forEach(function (btn) {
  //     btn.style.display = 'none';
  //   });
  // }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' лв.';
  }

  function openModal(lineItems, source) {
    pendingLineItems = lineItems;
    pendingSource = source;

    // Reset state
    phoneInput.value = '';
    phoneError.style.display = 'none';
    submitBtn.style.display = '';
    submitBtn.disabled = false;
    submitBtn.textContent = 'Потвърди поръчката';
    successEl.style.display = 'none';
    errorStateEl.style.display = 'none';
    overlay.querySelector('.one-click-modal__form').style.display = '';
    overlay.querySelector('.one-click-modal__note').style.display = '';

    // Render items
    itemsContainer.innerHTML = '';
    lineItems.forEach(function (item) {
      var div = document.createElement('div');
      div.className = 'one-click-modal__item';
      div.innerHTML =
        '<span class="one-click-modal__item-name">' + escapeHtml(item.title) + '</span>' +
        '<span class="one-click-modal__item-meta">x' + item.quantity +
        (item.price ? ' &middot; ' + formatMoney(item.price * item.quantity) : '') +
        '</span>';
      itemsContainer.appendChild(div);
    });

    overlay.style.display = 'flex';
    phoneInput.focus();
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    overlay.style.display = 'none';
    document.body.style.overflow = '';
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function validatePhone(raw) {
    // Strip spaces, dashes
    var digits = raw.replace(/[\s\-()]/g, '');
    // Accept 8 or 9 digit Bulgarian numbers (mobile starts with 8x, landline varies)
    if (/^\d{8,9}$/.test(digits)) {
      return '+359' + digits;
    }
    return null;
  }

  function handleSubmit() {
    phoneError.style.display = 'none';
    errorStateEl.style.display = 'none';

    var phone = validatePhone(phoneInput.value);
    if (!phone) {
      phoneError.textContent = 'Моля, въведете валиден телефонен номер.';
      phoneError.style.display = '';
      return;
    }

    if (!pendingLineItems.length) {
      phoneError.textContent = 'Няма избрани продукти.';
      phoneError.style.display = '';
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Изпращане...';

    var payload = {
      phone: phone,
      line_items: pendingLineItems.map(function (item) {
        return { variant_id: item.variant_id, quantity: item.quantity };
      }),
      source: pendingSource
    };

    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.success) {
          overlay.querySelector('.one-click-modal__form').style.display = 'none';
          submitBtn.style.display = 'none';
          overlay.querySelector('.one-click-modal__note').style.display = 'none';
          successEl.style.display = '';
        } else {
          errorStateEl.querySelector('p').textContent = data.error || 'Възникна грешка. Моля, опитайте отново.';
          errorStateEl.style.display = '';
          submitBtn.disabled = false;
          submitBtn.textContent = 'Потвърди поръчката';
        }
      })
      .catch(function () {
        errorStateEl.style.display = '';
        submitBtn.disabled = false;
        submitBtn.textContent = 'Потвърди поръчката';
      });
  }

  // Event listeners
  overlay.querySelector('.one-click-modal__close').addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });
  submitBtn.addEventListener('click', handleSubmit);
  phoneInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') handleSubmit();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.style.display !== 'none') closeModal();
  });

  // Product page buttons
  document.querySelectorAll('[data-one-click-buy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantSelect = document.querySelector('select[name="id"], input[name="id"]');
      var variantId = variantSelect ? parseInt(variantSelect.value) : null;
      var qtyInput = document.querySelector('input[name="quantity"]');
      var quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      var title = btn.getAttribute('data-product-title') || document.querySelector('.product-single__title')?.textContent?.trim() || 'Product';
      var price = parseInt(btn.getAttribute('data-product-price')) || 0;

      if (!variantId) return;

      openModal([{ variant_id: variantId, quantity: quantity, title: title, price: price }], 'product_page');
    });
  });

  // Cart page buttons
  document.querySelectorAll('[data-one-click-buy-cart]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var items = cart.items
            .filter(function (item) { return item.product_id !== 8831134531921; })
            .map(function (item) {
              return {
                variant_id: item.variant_id,
                quantity: item.quantity,
                title: item.product_title + (item.variant_title ? ' - ' + item.variant_title : ''),
                price: item.final_price
              };
            });

          if (items.length) {
            openModal(items, 'cart_page');
          }
        });
    });
  });
})();
